import { FileManagementFieldModel } from "../Interfaces/FileManagementFieldModel";

export function isFileManagementField(value: any): value is FileManagementFieldModel {
  if (value && value.files) {
    return Array.isArray(value.files);
  }
  return false;
}
